import { render, staticRenderFns } from "./marketingplugin.vue?vue&type=template&id=18522d69&scoped=true&"
import script from "./marketingplugin.vue?vue&type=script&lang=js&"
export * from "./marketingplugin.vue?vue&type=script&lang=js&"
import style0 from "./marketingplugin.vue?vue&type=style&index=0&id=18522d69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18522d69",
  null
  
)

export default component.exports